export default __webpack_public_path__ + "static/ZENPEPE-f777111c16dfa57ed0ce2392f2342206.jpg";